export default {
    data() {
        return {
            inputLabel: 'label-class',
        }
    },
    methods: {
        addClass(input) {
            const label = document.querySelector(`label[for='${input.id}']`)
            if (!label.classList.contains('toggle-label')) {
                label.classList.add('toggle-label')
            }
        },
        toggleClass(input) {
            const label = document.querySelector(`label[for='${input.id}']`)
            if (input.value.length <= 0) {
                label.classList.remove('toggle-label')
            }
        },
    },
}
